import { lazyWithRetries } from '@globals/lazyWithRetries'
import AdminPaths from '@globals/paths/admin'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const IntegrationsRoute = lazyWithRetries(() => import('.'))
const FtpRoute = lazyWithRetries(() => import('./ftp'))
const ConfigureFtpConnectionRoute = lazyWithRetries(() => import('./ftp/configure'))
const FtpSummaryRoute = lazyWithRetries(() => import('./ftp/viewSummary'))
const MsteamsRoute = lazyWithRetries(() => import('./msteams'))
const SsoRoute = lazyWithRetries(() => import('./sso'))
const SsoProviderRoute = lazyWithRetries(() => import('./sso/provider'))
const CreateSsoRoute = lazyWithRetries(() => import('./sso/create'))

const routes: RouteObject[] = [
  {
    path: AdminPaths.integrations(),
    element: (
      <StandardPageLayout
        maxWidth={1080}
        elementId="integrationsRoute"
        title={<T _str="Integrations" />}>
        <Suspense fallback={<RouteLoading />}>
          <IntegrationsRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AdminPaths.ftpIntegrations(':tab?'),
    element: (
      <StandardPageLayout
        elementId="ftpIntegrationRoute"
        maxWidth={1080}
        title={<T _str="FTP integration" />}>
        <Suspense fallback={<RouteLoading />}>
          <FtpRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AdminPaths.configureFtp(':connectionId?'),
    element: (
      <StandardPageLayout elementId="configureFtpConnectionsRoute" maxWidth={900}>
        <Suspense fallback={<RouteLoading />}>
          <ConfigureFtpConnectionRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AdminPaths.viewFtpSummary(':connectionId'),
    element: (
      <StandardPageLayout
        elementId="viewFtpSummaryRoute"
        maxWidth={1080}
        title={<T _str="FTP connection summary" />}>
        <Suspense fallback={<RouteLoading />}>
          <FtpSummaryRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AdminPaths.ms365Integrations(),
    element: (
      <StandardPageLayout
        elementId="ms365IntegrationsRoute"
        maxWidth={600}
        title={<T _str="Microsoft 365" />}>
        <Suspense fallback={<RouteLoading />}>
          <MsteamsRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AdminPaths.ssoIntegrations(),
    element: (
      <StandardPageLayout
        elementId="ssoIntegrationsRoute"
        maxWidth={600}
        title={<T _str="SSO (Single sign-on)" />}>
        <Suspense fallback={<RouteLoading />}>
          <SsoRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AdminPaths.createSso(),
    element: (
      <StandardPageLayout
        elementId="createSsoRoute"
        maxWidth={900}
        title={<T _str="Add SSO connection" />}>
        <Suspense fallback={<RouteLoading />}>
          <CreateSsoRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AdminPaths.ssoProvider(':ssoProviderId'),
    element: (
      <StandardPageLayout
        elementId="ssoProviderRoute"
        maxWidth={900}
        title={<T _str="View Kudos provider information" />}>
        <Suspense fallback={<RouteLoading />}>
          <SsoProviderRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
